import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { H4, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service";
import { User } from "../../../Types/UserManagement";

type Props = {
  user: User;
};

export function UserDetails({ user }: Props) {
  return (
    <Form>
      <Card>
        <CardHeader>
          <Row className="mb-2">
            <div className="profile-title">
              <div className="d-flex align-items-center gap-2">
                <Image
                  className="img-40 rounded-circle"
                  alt="edit-user"
                  src={dynamicImage("user/7.jpg")}
                />
                <div className="flex-grow-1">
                  <H4 className="mb-1">
                    {user.firstName} {user.lastName}
                  </H4>
                </div>
              </div>
            </div>
          </Row>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md={12} className="mb-3">
              <P className={"card-title mb-0"}>Personal Details</P>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>{"Full Name"}</Label>
                <Input
                  type="text"
                  placeholder="Company"
                  value={`${user?.firstName} ${user?.lastName}`}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>{"Email"}</Label>
                <Input
                  type="text"
                  placeholder="Company"
                  value={user?.email}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>{"Mobile Number"}</Label>
                <Input
                  type="text"
                  placeholder="Mobile Number"
                  value={user?.contactNumber}
                  disabled
                />
              </FormGroup>
            </Col>
             
          </Row>
          <Row>
           
            <Col sm="6" md="6">
              <FormGroup>
                <Label>{"Unit number"}</Label>
                <Input
                  type="text"
                  placeholder="Unit number"
                  value={user?.unitNumber}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup>
                <Label>{"Street number"}</Label>
                <Input
                  type="text"
                  placeholder="Street number"
                  value={user?.streetNumber}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup>
                <Label>{"Street Name"}</Label>
                <Input
                  type="text"
                  placeholder="Street Name"
                  value={user?.streetName}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup>
                <Label>{"Suburd"}</Label>
                <Input
                  type="text"
                  placeholder="suburd"
                  value={user?.suburb}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup>
                <Label>{"VIC postal code"}</Label>
                <Input
                  type="text"
                  placeholder="VIC postal code"
                  value={user?.vicPostalCode}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup>
                <Label>{"State"}</Label>
                <Input
                  type="text"
                  placeholder="State"
                  value={user?.state}
                  disabled
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
}
